var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.07 48c-.156-1.757-.071-3.461.447-5.104.32-1.024 1.136-1.687 2.135-2.002 1.423-.453 2.883-.777 4.31-1.206a15.752 15.752 0 0 0 2.5-.928c1.797-.895 2.094-2.19 1.257-4.038a62.784 62.784 0 0 1-2.483-6.28c-.641-1.954-.67-3.991-.139-6.016.762-2.93 2.924-4.897 5.919-5.309 2.17-.299 4.244-.077 6.083 1.262 2.746 1.996 3.26 4.865 2.94 7.98-.297 2.888-1.34 5.568-2.68 8.125-1.15 2.187-.717 3.578 1.563 4.478 1.49.588 3.071.936 4.611 1.394.632.19 1.288.328 1.887.592 1.165.515 2.024 1.335 2.168 2.699.15 1.428.271 2.858.412 4.352H17.067l.003.001z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.f5b00b5607e0999731af1282a67acdca.svg";
export { ForwardRef as ReactComponent };